module.exports = __webpack_public_path__ + "static/media/user_b.f9f26790.png";